export default {
  ads: 'آگهی ها',
  adSearch: 'جستجو آگهی ها',
  areaWidgetsUpdated: 'ابزارک های بخش بروز رسانی شد.',
  articles: 'مقالات',
  articleSearch: 'جستجو مقالات',
  ascending: 'صعودی',
  authenticated: 'فقط اعضا',
  availability: 'دسترسی',
  brand: 'برند',
  color: 'رنگ',
  count: 'تعداد',
  milliseconds: 'میلی ثانیه',
  descending: 'نزولی',
  everyone: 'همه',
  filter: 'فیلتر',
  icon: 'آیکن',
  promotion: 'پیشنهاد ویژه',
  imageHeight: 'ارتفاع تصویر',
  images: 'تصاویر',
  imageWidth: 'عرض تصویر',
  impression: 'تعداد بازدید',
  interval: 'بازه زمانی',
  item: 'آیتم',
  items: 'آیتم‌ها',
  link: 'پیوند',
  menu: 'منو',
  mostVisited: 'محبوب ترین ها',
  nav: 'فهرست',
  networks: {
    instagram: 'اینستاگرام',
    telegram: 'تلگرام',
    twitter: 'توئیتر'
  },
  newest: 'جدیدترین ها',
  newPage: 'صفحه جدید',
  order: 'ترتیب بر اساس',
  post: 'نوشته ها',
  price: 'قیمت',
  priceAfterDiscountMax: 'حداکثر قیمت بعد از تخفیف',
  priceAfterDiscountMin: 'حداقل قیمت بعد از تخفیف',
  product: 'کالا',
  productSort: 'مرتب سازی',
  providers: 'مشاوران',
  providerSearch: 'جستجو مشاوران',
  sales: 'تعداد فروش',
  samePage: 'همان صفحه',
  share: 'اشتراک گذاری',
  showImage: 'نمایش تصویر',
  showPrice: 'نمایش قیمت',
  showTitle: 'نمایش عنوان',
  slider: 'اسلایدر',
  social: 'شبکه های اجتماعی',
  sort: 'چینش',
  sortType: 'نوع مرتب سازی',
  speed: 'سرعت',
  subtitle: 'عنوان زیرین',
  tags: 'تگ ها',
  target: 'باز شدن در',
  text: 'متن',
  unauthenticated: 'فقط غیر اعضا',
  url: 'پیوند موارد بیشتر',
  viewData: 'View Data',
  viewName: 'View Name',
  widgetAvailability: 'دسترسی',
  widgetType: 'ابزارک',
  noWidgetAdded: 'ابزارکی اضافه نشده است',
  component: 'کامپوننت',
  componentName: 'نام کامپوننت',
  form: 'فرم',
  type: 'نوع',
  attribute: 'Attribute',
  data: 'Data',
  formInputs: 'ورودی های فرم',
  restUrl: 'آدرس رست',
  payAttentionToTheDetailsOn_widget:
    'در وارد کردن اطلاعات ابزارک {widget} دقت کنید',
  restMethod: 'متد رست',
  successMessage: 'پیام موفقیت',
  failureMessage: 'پیام عدم موفقیت',
  singleSection: 'تک بخشی',
  twoSection: 'دو بخشی',
  threeSection: 'سه بخشی',
  fourSection: 'چهار بخشی',
  baseAttributes: 'ویژگی های پایه',
  seoAttributes: 'ویژگی های سئو',
  paging: 'صفحه بندی',
  firstSection: 'بخش اول',
  secondSection: 'بخش دوم',
  thirdSection: 'بخش سوم',
  forthSection: 'بخش چهارم',
  testimonial: 'Testimonial',
  profession: 'حرفه',
  userImage: 'تصویر کاربر',
  questionnaire: 'پرسشنامه',
  section: 'ناحیه',
  accordion: 'آکاردئون',
  componentNames: {
    account: 'حساب کاربری',
    download: 'دانلود',
    introduction: 'بنر فصلی',
    featuresSlider: 'اسلایدر ویژگی ها',
    workflow: 'روند کاری',
    sidebarToggle: 'Sidebar toggle',
    contactUsForm: 'فرم تماس با ما',
    contactUsAddress: 'اطلاعات تماس',
    buisnessDescription: 'اطلاعات کسب و کار (باربانت)'
  },
  formItemNames: {
    text: 'متن (text)',
    checkbox: 'چند گزینه ای انتخابی (check-box)',
    textarea: 'متن بلند (textarea)',
    radio: 'تک انتخابی (radoi-button)',
    dropdown: 'لیست کشویی (dropdown)',
    link: 'لینک',
    submit: 'دکمه تایید (submit)'
  },
  displaySettings: 'تنظیمات نمایش',
  areaDisplaySettings: 'تنظیمات نمایش ناحیه',
  pageDisplaySettings: 'تنظیمات نمایش صفحه',
  fullScreen: 'تمام صفحه',
  downloadLinks: 'لینک های دانلود',
  downloadQRCode: 'QR کد',
  seasons: {
    spring: 'بهار',
    summer: 'تابستان',
    fall: 'پاییز',
    winter: 'زمستان'
  },
  pwa: 'PWA'
}
